// removed by extract-text-webpack-plugin
module.exports = {"title":"_1AsJ8sczGtY8JlCNicVMCk","btnFooter":"_2i5sPsnOGq6VaQ03AMy944","textareaEffect":"_1ZyMZGNIzG8215xTS2-IZT","itemGroup":"pztdDALxZqsiM9Dn-9d0R","imagePreviewList":"_2wLrs4Yi38KWY_LZCPV0jF","imagePreviewMin":"_1c0ivKSAwI25ykM-o0qgWQ","imgPreview":"_9pysbO1bGAUUCvbSLEcB-","deleteImage":"_2XuE0HzT1uRL5ccv3KEvOn","addImage":"_3cLyEcTfdUqQTcy5G_ZlDM","imageUpload":"_3aWf9rPXw3BajAwP1l-Dix","loaderImg":"_2ap17JZu5_lwu8WFtICcmr","editor":"_3OVaiWDSePKPQ83y4736WY","active":"_1uMaSHZRb3VBMrWLHmu9x2"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Modais/style.css
// module id = 628
// module chunks = 38